// extracted by mini-css-extract-plugin
export default {"table":"ChitietHoadon_table__1FF9I","cellWrapper":"ChitietHoadon_cellWrapper__+BKLK","image":"ChitietHoadon_image__Fc9hn","productStatus":"ChitietHoadon_productStatus__dUzh7"};